
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import AddList from './add-list.vue'
  @Component({
    name: 'AuditionSign',
    components: { AddList }
  })
export default class AuditionSign extends Vue {
    @Prop() dialogStkSign: boolean
    @Prop() title: string
    @Prop() remark: string
    @Prop() customerIntention: any
    addCustomer: any = {
      customerIntention: 4,
      stkShopReason: ''
    }
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    // 新建订单
    dialogOrderAdd: boolean = false
    order_modifyHeader: any = []
    order_optionList: any = []
    order_optionId: string = ''
    order_isAddType: string = 'add'
    order_itemValue: any = {}
    order_allData: any = []

    @Watch('dialogStkSign')
    getContent(val){
      this.addCustomer.stkShopReason = this.remark
      this.addCustomer.customerIntention = this.customerIntention

      this.getOrderList()
    }


    addOrderSuccess(val) {
      if(val) {
        this.addCustomer.type = 'true'
        this.$emit('audition-sign', this.addCustomer)
      }
      this.dialogOrderAdd = false
    }

    async getOrderList() {
      const res: any = await CourseModule.orderPage({ org_id: this.org_id })
      if (res.code === 200) {
        let header = res.data.page_section[0].entity.entity_fields
        for (var i = 0; i < header.length; i++) {
          const existsType: string = header[i].exists_type
          if (existsType.indexOf('modify') >= 0) {
            this.order_modifyHeader.push(header[i])
          }
        }
        this.order_optionId = res.data.page_section[0].entity.id
        this.order_allData = res.data
        this.orderOption()
      }
    }

    async orderOption() {
      const res: any = await CourseModule.options({ optionId: this.order_optionId, org_id: this.org_id })
      if (res.code === 200) {
        this.order_optionList = res.data
      }
    }



    // 添加占用弹窗关闭
    handleStkSignClose() {
      this.addCustomer.type = 'false'
      this.$emit('audition-sign', this.addCustomer)
    }
    // 新建订单
    handleStkSignNew() {
      this.dialogOrderAdd = true
    }
    // 添加占用弹窗确定
    handleStkSignTrue() {
      if (this.addCustomer.stkShopReason == '') {
        return false
      }
      this.addCustomer.type = 'true'
      this.$emit('audition-sign', this.addCustomer)
    }
}
